import { Route } from '@angular/router';

import { LoginComponent } from './';

export const loginState: Route = {
    path: 'login',
    component: LoginComponent,
    data: {
      authorities: [],
      pageTitle: 'login.title'
    }
};




// WEBPACK FOOTER //
// ./src/app/login/login.route.ts